import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const PrivateRoutes = ({ children }) => {
    const userState = useSelector(state => state.loginData.userData);

    return userState ? children : <Navigate to="/" />;
};

export default PrivateRoutes;

